(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('anomaly', {
            parent: 'functions_menu',
            url: '/anomaly?page&sort&search&searchTerm&fromDate&toDate&questionnaireId&answerAuthorUserId&taskId',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.anomaly.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/information/anomaly/anomaly.html',
                    controller: 'AnomalyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: '(answer_time),desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchTerm: $stateParams.searchTerm,
                        fromDate: $stateParams.fromDate,
                        toDate: $stateParams.toDate,
                        answerAuthorUserId: $stateParams.answerAuthorUserId,
                        questionnaireId: $stateParams.questionnaireId,
                        taskId: $stateParams.taskId
                    };
                }],
                filterAnswerAuthorUser: ['$stateParams', 'User', function($stateParams, User) {
                    if ($stateParams.answerAuthorUserId) {
                        return User.get({id: $stateParams.answerAuthorUserId}).$promise;
                    }
                    return null;
                }],

                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('information');
                    $translatePartialLoader.addPart('anomalyEvent');
                    $translatePartialLoader.addPart('informationEvent');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
